import styled from 'styled-components/native';

import dynamicSize from '@webtrader/core/dynamic-size';

export const Form = styled.View`
  padding: ${dynamicSize.convertSize(20)}px 0;
`;

export const FormField = styled.View`
  padding-bottom: ${dynamicSize.convertSize(18)}px;
`;

export const FormFieldRow = styled.View`
  flex-direction: row;
`;

export const EmailVerificationFieldRowItem = styled.View<{ isLast?: boolean }>`
  flex: ${({ isLast }) => (isLast ? 1 : 2)};
  justify-content: flex-end;

  padding-start: ${({ isLast }) => (!isLast ? 0 : dynamicSize.convertSize(5))}px;
  padding-end: ${({ isLast }) => (isLast ? 0 : dynamicSize.convertSize(5))}px;
`;
